import { Link } from "react-router-dom";
import { Play, ArrowRight, Video as VideoIcon } from "lucide-react";
import { Button } from "../ui/button";
import { videos } from "../../mock/mock";

const VideoSection = () => {
  const featured = videos.find((v) => v.featured) || videos[0];
  const others = videos.filter((v) => v.id !== featured.id).slice(0, 2);

  return (
    <section className="py-20 bg-gradient-to-br from-stone-50 via-orange-50 to-amber-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
            <VideoIcon className="w-4 h-4 text-orange-600" />
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Watch Our Story</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-3">
            See Aadi Gayanam in <span className="text-orange-600">Motion</span>
          </h2>
          <p className="text-stone-600">A picture may speak a thousand words, but a video shares a whole world of joy, curiosity and sanskaar.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {/* Featured video - large */}
          <div className="lg:col-span-2 bg-white rounded-3xl overflow-hidden shadow-xl border border-orange-100">
            <div className="relative aspect-video bg-stone-900">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${featured.youtubeId}?rel=0&modestbranding=1`}
                title={featured.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="p-6">
              <span className="text-[10px] font-bold text-white bg-orange-600 px-2.5 py-1 rounded-full uppercase tracking-wider">
                {featured.category}
              </span>
              <h3 className="font-display font-bold text-2xl text-stone-800 mt-3 mb-2">{featured.title}</h3>
              <p className="text-stone-600 text-sm leading-relaxed">{featured.description}</p>
            </div>
          </div>

          {/* Side videos list */}
          <div className="space-y-6">
            {others.map((v) => (
              <div key={v.id} className="bg-white rounded-3xl overflow-hidden shadow-md border border-orange-100 hover:shadow-xl transition-all">
                <div className="relative aspect-video bg-stone-900 group cursor-pointer">
                  <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover opacity-90" />
                  <a
                    href={`https://www.youtube.com/watch?v=${v.youtubeId}`}
                    target="_blank"
                    rel="noreferrer"
                    className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-colors"
                  >
                    <div className="w-14 h-14 rounded-full bg-white/95 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                      <Play className="w-6 h-6 text-orange-600 fill-orange-600 ml-1" />
                    </div>
                  </a>
                  <span className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] font-semibold px-2 py-0.5 rounded">
                    {v.duration}
                  </span>
                </div>
                <div className="p-4">
                  <span className="text-[10px] font-bold text-orange-700 uppercase tracking-wider">{v.category}</span>
                  <h4 className="font-display font-bold text-stone-800 mt-1 line-clamp-2">{v.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <Link to="/videos">
            <Button size="lg" className="bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-full px-8 h-12 shadow-lg btn-shine">
              Watch All Videos <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
